export default __webpack_public_path__ + "static/media/PythonIcon.6e1e195a.png";